<div [classList]="containerClassToAplly() + (hasGlobalMessages() ? '-global-message global-message' : '')">

  <app-notification></app-notification>

  <!-- Rendered immediately (no @defer) and the host reserves 40px via SCSS so
       that when the messages API resolves the banner already has space — no CLS. -->
  @if (!isInBlankComponent()) {
  <app-global-message class="sticky-top"></app-global-message>
  }

  @if (showAppHeader() && !isInBlankComponent()) {
  <app-header class="sticky-top header"></app-header>
  }

  @defer (on timer(0.5s)) {
  @if (!isMobile() && !isInBlankComponent()) {
  <div class="cart-preview"
    [ngClass]="{'cart-preview--height': !hasGlobalMessages(), 'cart-preview--height-global-message': hasGlobalMessages()}"
    [class.open]="showAppCartPreview()">
    <app-side-checkout></app-side-checkout>
  </div>
  }
  }

  @if(showAppCartPreview() && !isInBlankComponent()){
  <div class="backdrop-cart-preview" (click)="showCartPreview.set(false)"></div>
  }

  <!-- The height variants below all assumed the header was on screen. Routes without it
       (/preferences) still sit under the 40px global-message banner, which is a sibling of
       <main> rather than an overlay — so main kept a full-viewport height starting 40px down,
       and its bottom fell below the fold along with anything sticky pinned to it. -->
  <main id="main-content" class="main-container" appScrollToTop
    [class.header-showing]="showAppHeader() && !hasGlobalMessages()"
    [class.header-showing-global-message]="showAppHeader() && hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav]="showAppHeader() && !shouldShowCategoriesBar() && !hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav-global-message]="showAppHeader() && !shouldShowCategoriesBar() && hasGlobalMessages()"
    [class.global-message-showing]="!showAppHeader() && hasGlobalMessages()"
    [class.cart-preview-showing]="showAppCartPreview()" [class.mobile-main-container]="showMobileFooter()"
    [class.blur]="showCartPreview() && !isMobile()" [class.hidden-mobile-footer]="!showMobileFooter()">
    <router-outlet />
  </main>

  @if (showMobileFooter() && !isInBlankComponent()) {
  <app-mobile-footer-menu></app-mobile-footer-menu>
  }

  @if (loadingService.isShowGlobalLoading()) {
  <app-loading></app-loading>
  }

</div>